module.exports = __webpack_public_path__ + "static/media/logo.6387ab4d.svg";